






































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import GSurveyAnalyzeFilter from '@/views/GSurveyAnalyze/GSurveyAnalyzeFilter.vue';
import GSurveyChart from '@/views/GSurveyAnalyze/GSurveyChart.vue';
import GStatisticsChart from '@/views/GStatistics/GStatisticsChart.vue';
import GLoading from '@/components/GLoading.vue';
import GStatisticsBoxplotSubTableInfoTable from '@/components/GStatisticsBoxplotSubTableInfoTable.vue';
import { SurveyAnalysisTabelMapping } from '@/models/jgrow/survey-analysis-tabel-mapping';
import GOptionalData from '@/components/GOptionalData.vue';

@Component({
  name: 'GSurveyMetaPositiveActivity',
  components: {
    GLoading,
    GSurveyChart,
    GSurveyAnalyzeFilter,
    GTemplateTopicForm,
    GTitleBar,
    GCustomBreadCrumb,
    GStatisticsChart,
    GOptionalData,
    GStatisticsBoxplotSubTableInfoTable,
  },
  computed: {},
  methods: {},
})
export default class GSurveyMetaPositiveActivity extends mixins(GPageBase) {
  columns: any[] = []; // テーブル形式のテーブルカラム情報
  surveyAnalysisTabels: SurveyAnalysisTabelMapping[] = [];

  async mounted() {
    this.columns = [
      {
        title: 'コンピテンシー',
        key: 'competency',
        width: 180,
        align: 'center',
        slot: 'competency',
        className: 'g-survey-meta-positive-activity-table-cell-0',
      },
      {
        title: '7段階評価の平均値',
        key: 'avarage',
        width: 80,
        align: 'center',
        slot: 'avarage',
      },
      {
        title: 'ポジティブ回答率',
        key: 'positive',
        align: 'center',
        width: 80,
        slot: 'positive',
      },
      {
        title: 'アクティビティ(カッコ内は人数)',
        align: 'center',
        children: [
          {
            title: '1位',
            key: 'one',
            align: 'center',
            width: 160,
            slot: 'one',
          },
          {
            title: '2位',
            key: 'two',
            align: 'center',
            width: 160,
            slot: 'two',
          },
          {
            title: '3位',
            key: 'three',
            align: 'center',
            width: 160,
            slot: 'three',
          },
          {
            title: '4位',
            key: 'four',
            align: 'center',
            width: 160,
            slot: 'four',
          },
          {
            title: '5位',
            key: 'five',
            align: 'center',
            width: 160,
            slot: 'five',
          },
        ],
      },
    ];

    const rateTables: Map<number, SurveyAnalysisTabelMapping> = await surveyAnalyzeModule.getCompetencyAnswerTabels();
    this.surveyAnalysisTabels = [...rateTables.values()];
    this.surveyAnalysisTabels.sort((a, b: SurveyAnalysisTabelMapping) => b.getPositivePer() - a.getPositivePer());

    const rateSelectTableMap: Map<number, Map<number, SurveyAnalysisTabelMapping>> = await surveyAnalyzeModule.getActivitySelectAnswerTabels();
    const surveyAnalysisSelectTabelMap: Map<number, SurveyAnalysisTabelMapping[]> = new Map();
    rateSelectTableMap.forEach((value, key) => surveyAnalysisSelectTabelMap.set(key, [...value.values()]));
    // 降順にソート
    surveyAnalysisSelectTabelMap.forEach((value: SurveyAnalysisTabelMapping[]) => value.sort((a, b: SurveyAnalysisTabelMapping) => b.pointList[0].items - a.pointList[0].items));
    await surveyAnalyzeModule.setSurveyAnalysisSelectTabelMap(surveyAnalysisSelectTabelMap);
  }

  getCompetencyName(id: number): string {
    return surveyAnalyzeModule.competencyNameMap.get(id);
  }

  getActivityName(id: number): string {
    return surveyAnalyzeModule.activityNameMap.get(id);
  }

  getRateAverage(index: number): number {
    return this.surveyAnalysisTabels[index].getRateAverage();
  }

  getPositivePer(index: number): number {
    return this.surveyAnalysisTabels[index].getPositivePer();
  }

  getAnalysisSelectMapActivity(competencyID: number, index: number): SurveyAnalysisTabelMapping {
    return this.surveyAnalysisSelectTabelMap.get(competencyID)[index];
  }

  get surveyAnalysisSelectTabelMap(): Map<number, SurveyAnalysisTabelMapping[]> {
    return surveyAnalyzeModule.surveyAnalysisSelectTabelMap;
  }

  getActivityLabel(competencyID: number, index: number): string {
    return this.surveyAnalysisSelectTabelMap.get(competencyID) &&
      this.getAnalysisSelectMapActivity(competencyID, index) &&
      this.getAnalysisSelectMapActivity(competencyID, index).pointList[0].items > 0
      ? this.getActivityName(this.getAnalysisSelectMapActivity(competencyID, index).id) + ' (' + this.getAnalysisSelectMapActivity(competencyID, index).pointList[0].items + ')'
      : '';
  }
}
